import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const PastIndicator = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M11.2476856,0.65147631 L11.3304364,0.78147612 L15.5933311,8.23154848 L19.7816562,15.5383502 C20.3662817,16.5761505 19.712742,17.8900307 18.5830411,17.9934806 L18.4394036,18 L1.56182067,18 C0.392569563,18 -0.331125287,16.7276318 0.151640838,15.6694056 L0.218325297,15.5383502 L4.40789321,8.23154848 L8.66954505,0.78147612 C9.24135328,-0.215189077 10.6068601,-0.258522346 11.2476856,0.65147631 Z M10,1.81111111 L5.85374866,9.0605719 L1.68222222,16.3333333 L18.3166667,16.3333333 L14.1467371,9.0592824 L10,1.81111111 Z M9.99656003,12.2222222 C10.331384,12.2222222 10.6008485,12.3266545 10.8049536,12.5355191 C11.0090586,12.7443837 11.1111111,13.0115361 11.1111111,13.3369763 C11.1111111,13.6575592 11.0090586,13.9222829 10.8049536,14.1311475 C10.6008485,14.3400121 10.331384,14.4444444 9.99656003,14.4444444 C9.66632267,14.4444444 9.39915147,14.3400121 9.19504644,14.1311475 C8.99094141,13.9222829 8.88888889,13.6575592 8.88888889,13.3369763 C8.88888889,13.0163934 8.99094141,12.7504554 9.19504644,12.5391621 C9.39915147,12.3278689 9.66632267,12.2222222 9.99656003,12.2222222 Z M11.1111111,5.55555556 L10.8658009,11.1111111 L9.13419913,11.1111111 L8.88888889,5.55555556 L11.1111111,5.55555556 Z"
				id="pastIndicator"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

PastIndicator.propTypes = {
	color: PropTypes.string,
};

export default PastIndicator;
